import type { InternalNetworkAdEntityKind } from '@terra/shared-contracts-internal-network';
import type { OpenMainContentTabInput } from '../../../store/layoutStore';
import { TARGET_TYPE } from '../../../utils/target-scope.utils';
import { buildSurfaceAssetTabId } from './surfaceAsset.constants';

export function buildInternalNetworkAssetTab({
  entityKind,
  entityId,
  label,
}: {
  entityKind: InternalNetworkAdEntityKind;
  entityId: string;
  label: string;
}): OpenMainContentTabInput {
  return {
    id: buildSurfaceAssetTabId({
      targetType: TARGET_TYPE.INTERNAL_NETWORK,
      surfaceAssetKind: entityKind,
      entityId,
    }),
    title: label,
    type: 'surface-asset',
    data: {
      surfaceAssetKind: entityKind,
      entityId,
      targetType: TARGET_TYPE.INTERNAL_NETWORK,
    },
  };
}

export function buildCanonicalInternalNetworkAssetTab({
  assetId,
  label,
}: {
  assetId: string;
  label: string;
}): OpenMainContentTabInput {
  return {
    id: buildSurfaceAssetTabId({
      targetType: TARGET_TYPE.INTERNAL_NETWORK,
      surfaceAssetKind: 'ASSET',
      entityId: assetId,
    }),
    title: label,
    type: 'surface-asset',
    data: {
      surfaceAssetKind: 'ASSET',
      entityId: assetId,
      targetType: TARGET_TYPE.INTERNAL_NETWORK,
    },
  };
}
